import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { IDisposeToDto } from '~/models/modules/disposeToDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class DisposeToService extends ApiServiceBase {
  disposeToAdded: EventEmitter<any> = new EventEmitter();
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    getDisposeToLocations(siteId: number) {
        return this.http.get<any[]>(this._url(`/site/${siteId}`));
    }

    getDisposeTo(screenSiteId? : number){
      var paramsObj:any = {};
      paramsObj.screenSiteId = screenSiteId;
      let params = createHttpParams(paramsObj);
      return this.http.get<IDisposeToDto[]>(this._url(), {
        params,
      })
    }

    getDisposeToById(id: number){
      return this.http.get<IDisposeToDto[]>(this._url(`/${id}`));
    }

    getDisposeToGrid(paramsObj?: any, model?: any, screenSiteId? : number) {
      paramsObj = paramsObj || {};
      paramsObj.screenSiteId = screenSiteId;
      paramsObj.view = 'summary';
      let params = createHttpParams(paramsObj);

      return this.http
          .post<any[]>(this._url(`/grid-data`), model, {
              params,
              observe: 'response',
          })
          .pipe(map(augmentPaging));
  }

    createDisposeToLocation(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    updateDisposeToLocation(id: number,model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }

    getNbrOfDisposedItems(id: number) {
        return this.client.get(this._url(`/Number-of-disposed-items/${id}`));
      }

    deletedisposeTo(obj: any) {
        return this.client.put(this._url(`/deactivate`),obj);
    }

    deactivateDisposeToBatch(obj: any) {
      return this.client.put(this._url(`/batchDeactivate`), obj);
    }

    reactivateDisposeTo(id:number ,obj: any){
      return this.client.put(this._url(`/reactivate/${id}`), obj);
    }
    reactivateBatchDisposeTo(obj: any) {
      return this.client.put(this._url(`/batchReactivate`), obj);
    }

    GetDisposeToChart(disposeToId : number){
      return this.client.get(this._url(`/DisposeTo/${disposeToId}/Chart`));
    }


    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/DisposeTo${v}`);
    }
}
